module.exports = __webpack_public_path__ + "images/mobile/init/bg-0b9808ddaf7714e2953e33f702ae1815.png";